import { z } from 'zod';
import { accountReferenceSchema } from './account';
import { cashFlowTypeSchema } from './cash_flow';
import { entryInfoSchema } from './entry_info';
import { dateStringSchema, trustedBookYearSchema } from './periods';
import { detailedTransactionTypeSchema } from './transaction_type';
import { amountSchema } from './units';
import { voucherEntryIdSchema } from './voucher_entry_id';
import { voucherIdTypeSchema } from './voucher_id';

const entryRowSchema = z.object({
  entryId: voucherEntryIdSchema,
  bookYear: trustedBookYearSchema,
  voucherId: voucherIdTypeSchema,
  voucherText: z.string(),
  account: accountReferenceSchema,
  accountName: z.string(),
  date: dateStringSchema,
  unit: z.string().optional(),
  text: z.string().optional(),
  amount: amountSchema,
  balance: amountSchema,
  transactionType: entryInfoSchema(detailedTransactionTypeSchema),
  cashFlow: entryInfoSchema(cashFlowTypeSchema),
  counterAccount: entryInfoSchema(accountReferenceSchema),
  marked: z.boolean(),
});
type EntryRow = z.infer<typeof entryRowSchema>;

export { entryRowSchema, type EntryRow };
